import { render, staticRenderFns } from "./springFActivityHorse.vue?vue&type=template&id=51408f15&scoped=true"
import script from "./springFActivityHorse.vue?vue&type=script&lang=ts"
export * from "./springFActivityHorse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51408f15",
  null
  
)

export default component.exports